import { AuditEntryState } from './auditEntryState';

export class ProfileHistoryProperty {
  propertyName: string;
  oldValue: string;
  newValue: string;
}

export const propertyDescription = (state: string, prop: ProfileHistoryProperty): string => {
  switch (state) {
    case AuditEntryState.EntityAdded:
      return `<b>${prop.newValue ?? 'No value'}</b> was added to <b>${prop.propertyName}</b>`;
    case AuditEntryState.EntityDeleted:
      return `<b>${prop.oldValue ?? 'No value'}</b> was deleted from  <b>${prop.propertyName}</b>`;
    default:
      return `<b>${prop.propertyName}</b> changed from <b>${
        prop.oldValue ?? 'No value'
      }</b> to <b>${prop.newValue ?? 'No value'}</b>`;
  }
};
